
import './IgongChartOtherType.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import React, { useState, useEffect } from 'react';

const IgongChartOtherType = ({data}) => {

    const [list, setList] = useState([]);
    const typeCountMap = {}; // 각 typeName 등장 횟수 저장

    useEffect(() => {
        console.log(data, 'data --------');
        fncSelect_list();
    }, [data]);

    function fncSelect_list() {
            fnc.sendAxios('/igongAssess_chart/detail/select/otherType', {}, (res) => {
                if (res && Array.isArray(res)) {
                    const newList = getRecords(res);
                    setList(newList);
                } else {
                alert('검색에 실패했습니다(schoolList)');
                }
            });
    
            function getRecords(res) {
                const records = [];
                const typeCountMap = {};
                const jipyo1CountMap = {}; // 🔸 지표1 병합용
              
                res.forEach(item => {
                  let typeName = item["유형명칭"];//노벨형, 잡스형 ...
          
                  const matched = data.find(d => typeName.substring(0, 2) === d.name);
                  const percent = matched ? matched.percent : 0;

                  typeName = `${typeName}\n${percent}%`;
              
                  const jipyo1 = item["지표1"];
                  const jipyo2 = item["지표2"];
              
                  // 병합용 카운트
                  typeCountMap[typeName] = (typeCountMap[typeName] || 0) + 1;
                  jipyo1CountMap[jipyo1] = (jipyo1CountMap[jipyo1] || 0) + 1;
              
                  records.push({
                    typeName,
                    jipyo1,
                    jipyo2,
                    talent1: item["달란트1"],
                    talent2: item["달란트2"],
                    jinro: item["진로계열"],
                    reading: item["독서계열"]
                  });
                });
              
                // 병합 정보 추가
                records.forEach((record, index) => {
                  record.rowSpan_typeName =
                    index === 0 || record.typeName !== records[index - 1].typeName
                      ? typeCountMap[record.typeName] : 0;
              
                  record.rowSpan_jipyo1 =
                    index === 0 || record.jipyo1 !== records[index - 1].jipyo1
                      ? jipyo1CountMap[record.jipyo1] : 0;
                });
              
                return records;
            }
    }              
//=========================================
  return (
    <div className='IgongChartOtherType'>
    <div className='title'>학업역량 기초 평가</div>

        <table className="table-hong table-main">
        <thead>
            <tr>
                <th rowSpan="2">유형명칭</th>
                <th colSpan="2">지표ㅣ진단결과 분석</th>
                <th colSpan="2">발달된 달란트</th>
                <th rowSpan="2">추천 진로계열</th>
                <th rowSpan="2">추천 진로독서 계열</th>
            </tr>
        </thead>

                <tbody>
                    {list.map((item, index) => (
                        <tr key={index}>
                        {/* 유형명칭 머지 */}
                        {item.rowSpan_typeName > 0 && (
                            <td rowSpan={item.rowSpan_typeName}>{item.typeName}</td>
                        )}

                        <td>{item.jipyo2}</td>

                        {/* 지표1 병합 */}
                        {item.rowSpan_jipyo1 > 0 && (
                            <td rowSpan={item.rowSpan_jipyo1}>{item.jipyo1}</td>
                        )}

                        <td>{item.talent1}</td>
                        <td>{item.talent2}</td>
                        <td className="left-align">{item.jinro}</td>
                        <td className="left-align">{item.reading}</td>
                        </tr>
                    ))}
                </tbody>
        </table>


    </div>

  );
};

export default IgongChartOtherType;